module.exports = __webpack_public_path__ + "img/coach2.6f8e75b0.png";